<template>
  <section style="width: 85%;margin: auto">
    <div class="mt-16 pb-6 text-center">
      <h1>{{ $t('about_partner_title') }}</h1>
      <h5 style="width: 700px;margin: auto">{{ $t('about_partner_subtitle') }}</h5>
      <div>
        <v-row>
          <v-col
              class="d-flex justify-center align-center"
              v-for="(partner,i) in partners"
              :key="i"
              cols="6"
                 xl="3"
                 lg="3"
                 md="6"
                 sm="6"
          >
            <img  :src="partner" alt="images">
          </v-col>
        </v-row>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'partners',
  data(){
    return{
    }
  }
}
</script>
<style scoped>
img{
  width: 265px;
}
</style>
